export interface Episode {
  id: string;
  number: number;
  videoId: string;
  title: string;
  duration: string;
  date: string;
  beer: string;
  beerBrewery: string;
  category: string;
  thumbnail: string;
  status: string;
  difficulty: number;
  timeSpent: string;
  cost: string;
  verdict: string;
}

export const episodes: Episode[] = [
  {
    id: 'ep24',
    number: 24,
    videoId: 'TItZpIUpevI',
    title: '1987 Ford F-150 Carburetor Rebuild',
    duration: '42:17',
    date: 'Mar 14, 2026',
    beer: '"Midnight Oil" Oatmeal Stout',
    beerBrewery: 'Half Acre Beer Co. – Chicago',
    category: 'Engine',
    thumbnail: 'https://public.readdy.ai/ai/img_res/88b9220a474a8c4cee745a0fa4fc1c34.jpg',
    status: 'Fixed',
    difficulty: 4,
    timeSpent: '3 Days',
    cost: '$87.40',
    verdict: 'Rebuilt from scratch. Three stripped bolts, one snapped fuel line, and a 47-year-old carburetor that had never been touched. The stout was absolutely earned.',
  },
  {
    id: 'ep23',
    number: 23,
    videoId: 'dQw4w9WgXcQ',
    title: 'Welding a Cracked Lawn Tractor Frame',
    duration: '31:54',
    date: 'Mar 1, 2026',
    beer: '"Rustbelt Amber" Ale',
    beerBrewery: 'Great Lakes Brewing Co. – Cleveland',
    category: 'Welding',
    thumbnail: 'https://readdy.ai/api/search-image?query=close%20up%20shot%20of%20bright%20welding%20sparks%20flying%20from%20a%20cracked%20metal%20lawn%20tractor%20frame%20in%20a%20dark%20garage%20workshop%20dramatic%20orange%20sparks%20and%20blue%20welding%20arc%20against%20dark%20background%20industrial%20repair%20scene%20cinematic%20lighting&width=480&height=270&seq=ep-thumb-23&orientation=landscape',
    status: 'Fixed',
    difficulty: 3,
    timeSpent: '1 Day',
    cost: '$12.00',
    verdict: 'Frame cracked clean through underneath the seat mount. V-groove weld, grind flush, two coats of chassis black. Rock solid. The Amber hit different after that one.',
  },
  {
    id: 'ep22',
    number: 22,
    videoId: 'dQw4w9WgXcQ',
    title: 'Seized Brake Caliper Restoration',
    duration: '28:40',
    date: 'Feb 15, 2026',
    beer: '"Double Clutch" IPA',
    beerBrewery: 'Founders Brewing Co. – Grand Rapids',
    category: 'Brakes',
    thumbnail: 'https://readdy.ai/api/search-image?query=close%20up%20shot%20of%20a%20rusty%20seized%20automotive%20brake%20caliper%20being%20disassembled%20on%20a%20dark%20workshop%20floor%20with%20brake%20dust%20and%20grease%20dramatic%20side%20lighting%20from%20a%20workshop%20lamp%20metallic%20textures%20gritty%20garage%20repair%20atmosphere&width=480&height=270&seq=ep-thumb-22&orientation=landscape',
    status: 'Fixed',
    difficulty: 2,
    timeSpent: '4 Hours',
    cost: '$34.95',
    verdict: 'Piston was completely seized with 8 years of brake dust packed in. Heat gun, C-clamp, and a lot of patience. Rebuilt with a fresh seal kit. Pedal feel is night and day.',
  },
  {
    id: 'ep21',
    number: 21,
    videoId: 'dQw4w9WgXcQ',
    title: 'Dead Riding Mower Ignition Fix',
    duration: '19:22',
    date: 'Feb 2, 2026',
    beer: '"Yard Work" Wheat Beer',
    beerBrewery: "Bell's Brewery – Kalamazoo",
    category: 'Small Engine',
    thumbnail: 'https://readdy.ai/api/search-image?query=close%20up%20shot%20of%20a%20vintage%20riding%20lawn%20mower%20ignition%20switch%20and%20wiring%20harness%20on%20a%20dark%20concrete%20garage%20floor%20tools%20and%20electrical%20tape%20scattered%20around%20dramatic%20overhead%20warm%20lighting%20gritty%20small%20engine%20repair%20scene&width=480&height=270&seq=ep-thumb-21&orientation=landscape',
    status: 'Fixed',
    difficulty: 2,
    timeSpent: '2 Hours',
    cost: '$18.50',
    verdict: 'Ignition switch corroded to nothing inside. $18 replacement part off eBay, 20 minutes of wiring. Fired up first crank. Easiest beer I ever earned.',
  },
  {
    id: 'ep20',
    number: 20,
    videoId: 'dQw4w9WgXcQ',
    title: 'Rusted Exhaust Manifold Removal',
    duration: '55:08',
    date: 'Jan 20, 2026',
    beer: '"Ironworks" Porter',
    beerBrewery: 'Dogfish Head Craft Ales – Milton',
    category: 'Exhaust',
    thumbnail: 'https://readdy.ai/api/search-image?query=close%20up%20shot%20of%20a%20heavily%20rusted%20exhaust%20manifold%20and%20corroded%20bolts%20on%20a%20car%20engine%20block%20in%20a%20dark%20garage%20workshop%20dramatic%20chiaroscuro%20lighting%20heavy%20rust%20oxidation%20textures%20cinematic%20automotive%20repair%20atmosphere%20gritty%20detail&width=480&height=270&seq=ep-thumb-20&orientation=landscape',
    status: 'Fixed',
    difficulty: 5,
    timeSpent: '2 Days',
    cost: '$214.00',
    verdict: 'Two broken studs, one drill bit casualty, and a torch that nearly took out the wiring loom. Worst manifold job I\'ve done. The Porter was cold and it was deserved. Every drop.',
  },
  {
    id: 'ep19',
    number: 19,
    videoId: 'dQw4w9WgXcQ',
    title: 'Generator Carburetor Deep Clean',
    duration: '24:33',
    date: 'Jan 8, 2026',
    beer: '"Off-Grid" Session Lager',
    beerBrewery: 'Sierra Nevada Brewing Co. – Chico',
    category: 'Small Engine',
    thumbnail: 'https://readdy.ai/api/search-image?query=close%20up%20shot%20of%20a%20portable%20generator%20carburetor%20disassembled%20into%20multiple%20small%20pieces%20laid%20out%20on%20a%20clean%20white%20rag%20on%20a%20dark%20workbench%20carburetor%20cleaner%20spray%20can%20and%20small%20brush%20nearby%20warm%20workshop%20lighting%20detailed%20mechanical%20components&width=480&height=270&seq=ep-thumb-19&orientation=landscape',
    status: 'Fixed',
    difficulty: 2,
    timeSpent: '3 Hours',
    cost: '$6.00',
    verdict: 'Varnished jets from old fuel sitting in the tank all winter. Spray cleaner, compressed air, and a strand of copper wire. Generator runs better than new. Session lager, session fix.',
  },
];
